import moment from 'moment';

const rendsInOrder = [
  'default', 'desktop', 'tablet', 'mobile_web', 'mobile_app', 'connectedtv'
];

const isMatchUrl = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export default {
  methods: {
    formattedDate(dt) {
      const utcMoment = moment(dt).fromNow();
      return utcMoment;
    },
    mediumTitle(result) {
      const n = 75;
      return (result.name.length > n) ? `${result.name.substr(0, n - 1)}...` : result.name;
    },
    networkName(result) {
      return (result.network) ? result.network.name : null;
    },
    secondsToHms(d) {
      if (d) {
        d = Number(d);
        const h = Math.floor(d / 3600);
        const m = Math.floor((d % 3600) / 60);
        const s = Math.floor((d % 3600) % 60);
        let result = '';
        if (h > 0) {
          result += h < 10 ? `0${h}:` : `${h}:`;
        }
        result += m < 10 ? `0${m}:` : `${m}:`;
        result += s < 10 ? `0${s}` : `${s}`;
        return result;
      } else {
        return null;
      }
    },
    getVideoPoster(mediaItem) {
      const baseUrl = process.env.THUMBNAIL_BASE_URL;
      const { poster, ingestType, customThumbnail } = mediaItem;
      let posterUrl = '/static/media-item-poster-placeholder.svg';
      if (ingestType === 'mediaSource') {
        if (isMatchUrl.test(poster.default)) {
          return posterUrl;
        } else {
          posterUrl = `//${baseUrl}/${poster.default}`;
        }
      } else if (poster || customThumbnail) {
        const defaultUrl = customThumbnail || poster.default;
        if (isMatchUrl.test(defaultUrl)) {
          return defaultUrl;
        }
        posterUrl = `//${baseUrl}/${defaultUrl}`;
      }
      return posterUrl;
    },
    getVideoType(data) {
      let rv = 'mp4';
      if (Object.keys(data.renditions).length > 0) {
        for (let i = 0; i < rendsInOrder.length; i += 1) {
          if (data.renditions[rendsInOrder[i]]) {
            rv = data.renditions[rendsInOrder[i]][0].type;
            break;
          }
        }
      }
      return rv;
    },
    getVideoSource(data) {
      const baseUrl = process.env.TRANSCODE_BASE_URL;
      let rv = null;
      if (Object.keys(data.renditions).length > 0) {
        for (let i = 0; i < rendsInOrder.length; i += 1) {
          if (data.renditions[rendsInOrder[i]]) {
            rv = data.renditions[rendsInOrder[i]][0].src;
            break;
          }
        }
      }
      return isMatchUrl.test(rv) ? rv : `//${baseUrl}/${rv}`;
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared-components/videomixins.js